module.exports = __webpack_public_path__ + "img/pied-diabetique.00a54f26.jpg";